module.exports = "/assets/8bca3630aee0654ab6a04e1b8de49ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/small/eurostar.png
// module id = 228
// module chunks = 0